export default __webpack_public_path__ + "static/media/scatterWin.32c2ab76.mp3";